// frontend_react/src/components/paymodal/TicketPanel.jsx

import React from 'react';
import { formatEUR } from './constants';
import Receipt from './Receipt';

/**
 * TicketPanel — étape 4.
 *
 * Utilise Receipt.jsx du même dossier paymodal/.
 * fetchReceiptFull retourne { company, receipt, lines, payments }
 * Receipt.jsx attend : full.total_ttc, full.total_ht, full.lines[].name, full.lines[].price_ht
 *
 * On adapte le format ici avant de passer à Receipt.
 */
const TicketPanel = ({
    totals,
    paymentHistory = [],
    cashPaymentLog = [],  // [{ amount_due, cash_given, cash_change }]
    fullReceipt    = null,
    pdfUrl         = null,
    onFinish,
    onFinishWithTicket,
}) => {
    // Adapter { company, receipt, lines, payments } → format attendu par Receipt.jsx
    const receiptForDisplay = fullReceipt ? {
        ...fullReceipt.receipt,
        // Receipt.jsx cherche full.total_ttc / total_ht / total_vat
        total_ttc: fullReceipt.receipt?.amount_including_tax,
        total_ht:  fullReceipt.receipt?.amount_excluding_tax,
        total_vat: (
            (fullReceipt.receipt?.amount_including_tax ?? 0) -
            (fullReceipt.receipt?.amount_excluding_tax ?? 0)
        ),
        // Receipt.jsx cherche full.number et full.date
        number: fullReceipt.receipt?.number,
        date:   fullReceipt.receipt?.date_issue ?? fullReceipt.receipt?.date,
        // Receipt.jsx cherche line.name et line.price_ht
        // SalesLine.serialize() retourne wording et unit_price
        lines: (fullReceipt.lines ?? []).map(l => ({
            ...l,
            name:     l.wording,
            price_ht: l.unit_price,
        })),
    } : null;

    return (
        <div className="dark-card success-panel">
            <div className="ticket-panel-scroll">
            <div className="ticket-panel-scroll">
                <div className="success-check">✓</div>
                <h2 className="success-title">Paiement Validé</h2>

                <p className="text-muted" style={{ fontSize: 14, margin: '4px 0 0 0' }}>
                    Total TTC&nbsp;: {formatEUR(totals.totalTTC)}
                </p>

            {paymentHistory.length > 1 && (
                <div className="success-history">
                    {paymentHistory.map(p => (
                        <div key={p.id} className="success-history-row">
                            <span>{p.label}</span>
                            <span>{formatEUR(p.amount)}</span>
                        </div>
                    ))}
                </div>
            )}

            {/* Détail espèces : montant dû / reçu / rendu */}
            {cashPaymentLog.length > 0 && (
                <div className="dark-card" style={{ width: '100%', marginTop: 8, padding: '10px 14px', fontSize: 13 }}>
                    {cashPaymentLog.map((c, i) => (
                        <div key={i}>
                            {cashPaymentLog.length > 1 && (
                                <div className="text-muted" style={{ fontSize: 11, marginBottom: 4 }}>
                                    Paiement espèces #{i + 1}
                                </div>
                            )}
                            <div className="success-history-row">
                                <span>Total dû</span>
                                <span>{formatEUR(c.amount_due)}</span>
                            </div>
                            <div className="success-history-row">
                                <span>Espèces reçues</span>
                                <span>{formatEUR(c.cash_given)}</span>
                            </div>
                            <div className="success-history-row" style={{ color: '#4fabf7', fontWeight: 'bold' }}>
                                <span>Monnaie rendue</span>
                                <span>{formatEUR(c.cash_change)}</span>
                            </div>
                        </div>
                    ))}
                </div>
            )}

                {receiptForDisplay && (
                    <div style={{ marginTop: 12 }}>
                    <Receipt
                        full={receiptForDisplay}
                        showVatDetail={true}
                        showLegalMentions={true}
                    />
                </div>
            )}

            {pdfUrl && (
                <a
                    href={pdfUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="pill-btn outline"
                    style={{ marginTop: 10, textDecoration: 'none', width: '100%', justifyContent: 'center' }}
                >
                    📄 Ouvrir le PDF
                </a>
            )}

            </div>
            </div>

            <div className="success-actions ticket-panel-actions">
                <button className="pill-btn blue success-btn" onClick={onFinishWithTicket}>
                    TERMINER &amp; IMPRIMER TICKET
                </button>
                <button className="pill-btn outline success-btn" onClick={onFinish}>
                    TERMINER SANS TICKET
                </button>
            </div>
        </div>
    );
};

export default TicketPanel;